<template>
  <div>
    <el-card>
      <div slot="header"
           class="clearfix">
        <breadcrumb>
          <span slot="one">系统管理</span>
          <span slot="two">合同管理</span>
          <span slot="three">{{ typeText }}</span>
        </breadcrumb>
        <div class="btn"
             style="float: right; margin-top: -26px">
          <el-button type="primary"
                     size="small"
                     @click="actGoBack">返回
          </el-button>
        </div>
      </div>

      <el-form label-width="120px"
               :model="detailForm"
               ref="form"
               label-suffix=":"
               v-loading="detailDataLoading">
        <el-row>
          <el-col :span="24">
            <el-form-item label="合同名称"
                          :verify="['NotNull']"
                          prop="title">
              <el-input v-model="detailForm.title"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属部门"
                          :verify="['NotNull']"
                          prop="departId">
              <depart-select v-model="detailForm.departId"
                             clearable
                             placeholder="请选择所属部门"></depart-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同类型"
                          :verify="['NotNull']"
                          prop="type">
              <dict-select placeholder="请选择合同类型"
                           v-model="detailForm.type"
                           clearable
                           code="contractType"></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="其他合同类型"
                          :verify="detailForm.type==='3'?['NotNull']:[]"
                          prop="otherType">
              <el-input v-model="detailForm.otherType"
                        clearable
                        :disabled="detailForm.type!=='3'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同对方"
                          :verify="['NotNull']"
                          prop="partyB">
              <el-input v-model="detailForm.partyB"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同金额"
                          :verify="['NotNull','Number']"
                          prop="money">
              <el-input v-model="detailForm.money"
                        clearable>
                <template slot="suffix">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结算方式"
                          :verify="['NotNull']"
                          prop="payMethod">
              <dict-select placeholder="请选择结算方式"
                           v-model="detailForm.payMethod"
                           clearable
                           code="contractPayMethod"></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同有效期"
                          :verify="['NotNull','Number']"
                          prop="validPeriod">
              <el-input v-model="detailForm.validPeriod"
                        clearable>
                <template slot="suffix">年</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同签订日期（我方）"
                          prop="partyADate">
              <el-date-picker v-model="detailForm.partyADate"
                              type="date"
                              placeholder="请选择日期"
                              value-format="yyyy-MM-dd"
                              style="width: 100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同签订日期（对方）"
                          prop="partyADate">
              <el-date-picker v-model="detailForm.partyBDate"
                              type="date"
                              placeholder="请选择日期"
                              value-format="yyyy-MM-dd"
                              style="width: 100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="合同附件"
                          prop="attachment">
              <file-upload :action="fileUploadURL"
                           v-model="detailForm.attachment"
                           style="display: inline-block;margin-right: 10px;"
                           name="files"
                           list-type="picture-card"
                           show-import-control
                           :limit="1">
              </file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item class="footer-btn">
          <el-button type="primary"
                     @click="addOrEditHandle"
                     :loading="saveLoading">保存
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import mixinFormModule from '@/mixins/form-module/primary.js'
import FileUpload from "@/views/numberSelection/fileUpload.vue";

export default {
  mixins: [mixinFormModule],

  components: {FileUpload},

  data() {
    return {
      mixinFormModuleOptions: {
        detailDataURL: this.$api.contractDetail,
        addDataURL: this.$api.contractAdd,
        editDataURL: this.$api.contractEdit
      },
      fileUploadURL: this.$api.fileUploadURL,
    }
  },

  created() {
    this.getDetailData()
  }

}
</script>

<style scoped
       lang="less">

</style>
